import { useStaticQuery, graphql } from "gatsby";

export const useStrapiFaqCategories = () => {
  const data = useStaticQuery(graphql`
    query GetFaqCategories { 
      strapi {
        faqCategories {
          id
          name {
            ...LanguageText
          }
          items {
            id
            faq_item { 
              ...FaqItem
            }
          }
        }
      }
    }
  `);

  return data.strapi.faqCategories;
}